const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "199px",
    height: "40px",
    viewBox: "0 0 198 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 64.519531 14.484375 L 64.519531 10.699219 L 72.082031 10.699219 L 72.082031 7.757812 L 64.519531 7.757812 L 64.519531 4.203125 L 73.085938 4.203125 L 73.085938 1.171875 L 60.773438 1.171875 L 60.773438 13.566406 C 60.773438 15.75 62.53125 17.515625 64.703125 17.515625 L 73.382812 17.515625 L 73.382812 14.484375 Z M 64.519531 14.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 87.613281 1.171875 L 87.613281 11.09375 L 79.511719 1.171875 L 76.386719 1.171875 L 76.386719 17.515625 L 80.113281 17.515625 L 80.113281 7.59375 L 88.238281 17.515625 L 91.332031 17.515625 L 91.332031 1.171875 Z M 87.613281 1.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 104.039062 1.171875 L 100.3125 1.171875 L 93.054688 17.515625 L 96.914062 17.515625 L 102.152344 4.886719 L 104.738281 11.148438 L 102.90625 11.148438 C 101.996094 11.148438 101.179688 11.691406 100.824219 12.53125 L 100.199219 14.015625 L 105.917969 14.015625 L 107.367188 17.515625 L 111.324219 17.515625 Z M 104.039062 1.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 131.335938 1.171875 L 128.242188 1.171875 L 122.238281 11.332031 L 116.140625 1.171875 L 113.023438 1.171875 L 113.023438 17.515625 L 116.554688 17.515625 L 116.554688 7.921875 L 121.328125 15.796875 L 123.03125 15.796875 L 127.824219 7.710938 L 127.84375 17.523438 L 131.382812 17.523438 L 131.332031 1.179688 Z M 131.335938 1.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 139 14.484375 L 139 10.699219 L 146.5625 10.699219 L 146.5625 7.757812 L 139 7.757812 L 139 4.203125 L 147.5625 4.203125 L 147.5625 1.171875 L 135.257812 1.171875 L 135.257812 13.566406 C 135.257812 15.75 137.015625 17.515625 139.1875 17.515625 L 147.867188 17.515625 L 147.867188 14.484375 Z M 139 14.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 154.636719 14.4375 L 154.636719 1.171875 L 150.871094 1.171875 L 150.871094 17.515625 L 162.808594 17.515625 L 162.808594 14.433594 L 154.636719 14.433594 Z M 154.636719 14.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 76.027344 26.074219 C 75.277344 24.851562 74.21875 23.902344 72.863281 23.214844 C 71.5 22.542969 69.945312 22.203125 68.171875 22.203125 L 60.773438 22.203125 L 60.773438 38.539062 L 68.171875 38.539062 C 69.945312 38.539062 71.5 38.203125 72.863281 37.53125 C 74.21875 36.859375 75.277344 35.898438 76.027344 34.671875 C 76.78125 33.4375 77.160156 32.007812 77.160156 30.375 C 77.160156 28.742188 76.78125 27.3125 76.027344 26.078125 Z M 71.886719 34.078125 C 70.917969 34.988281 69.617188 35.4375 67.988281 35.4375 L 64.535156 35.4375 L 64.535156 25.308594 L 67.988281 25.308594 C 69.617188 25.308594 70.917969 25.757812 71.886719 26.675781 C 72.855469 27.582031 73.34375 28.820312 73.34375 30.371094 C 73.34375 31.925781 72.851562 33.160156 71.886719 34.078125 Z M 71.886719 34.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 83.742188 35.507812 L 83.742188 31.730469 L 91.304688 31.730469 L 91.304688 28.792969 L 83.742188 28.792969 L 83.742188 25.238281 L 92.304688 25.238281 L 92.304688 22.207031 L 79.996094 22.207031 L 79.996094 34.601562 C 79.996094 36.773438 81.757812 38.542969 83.925781 38.542969 L 92.609375 38.542969 L 92.609375 35.511719 L 83.742188 35.511719 Z M 83.742188 35.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 106.828125 22.203125 L 106.828125 32.128906 L 98.734375 22.203125 L 95.613281 22.203125 L 95.613281 38.539062 L 99.339844 38.539062 L 99.339844 28.625 L 107.460938 38.539062 L 110.554688 38.539062 L 110.554688 22.203125 Z M 106.828125 22.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 112.578125 22.203125 L 112.578125 25.289062 L 117.789062 25.289062 L 117.789062 38.539062 L 121.566406 38.539062 L 121.566406 25.289062 L 126.777344 25.289062 L 126.777344 22.203125 Z M 112.578125 22.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 128.800781 22.203125 L 128.800781 38.539062 L 132.578125 38.539062 L 132.578125 22.203125 Z M 128.800781 22.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 147.855469 31.167969 C 147.289062 30.527344 146.605469 30.066406 145.820312 29.769531 C 145.027344 29.476562 144.007812 29.179688 142.769531 28.882812 C 141.578125 28.617188 140.683594 28.351562 140.101562 28.078125 C 139.519531 27.800781 139.234375 27.382812 139.234375 26.832031 C 139.234375 26.285156 139.480469 25.8125 139.988281 25.476562 C 140.488281 25.128906 141.269531 24.964844 142.328125 24.964844 C 143.824219 24.964844 145.332031 25.394531 146.839844 26.242188 L 148.011719 23.375 C 147.257812 22.90625 146.394531 22.546875 145.402344 22.300781 C 144.40625 22.054688 143.386719 21.921875 142.351562 21.921875 C 140.867188 21.921875 139.605469 22.148438 138.5625 22.605469 C 137.535156 23.054688 136.761719 23.667969 136.253906 24.4375 C 135.734375 25.210938 135.480469 26.070312 135.480469 27.019531 C 135.480469 28.109375 135.765625 28.980469 136.335938 29.632812 C 136.898438 30.285156 137.578125 30.765625 138.371094 31.050781 C 139.167969 31.347656 140.183594 31.644531 141.414062 31.9375 C 142.230469 32.132812 142.871094 32.296875 143.339844 32.460938 C 143.820312 32.613281 144.207031 32.820312 144.511719 33.074219 C 144.808594 33.328125 144.960938 33.65625 144.960938 34.042969 C 144.960938 34.574219 144.703125 35.003906 144.195312 35.320312 C 143.675781 35.636719 142.894531 35.800781 141.816406 35.800781 C 140.859375 35.800781 139.890625 35.636719 138.933594 35.332031 C 137.96875 35.015625 137.144531 34.605469 136.441406 34.097656 L 135.160156 36.945312 C 135.894531 37.507812 136.859375 37.957031 138.0625 38.304688 C 139.261719 38.660156 140.515625 38.832031 141.796875 38.832031 C 143.28125 38.832031 144.554688 38.605469 145.59375 38.160156 C 146.632812 37.703125 147.417969 37.097656 147.933594 36.324219 C 148.453125 35.554688 148.707031 34.699219 148.707031 33.769531 C 148.707031 32.679688 148.421875 31.808594 147.863281 31.179688 Z M 147.855469 31.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 149.21875 22.203125 L 149.21875 25.289062 L 154.433594 25.289062 L 154.433594 38.539062 L 158.195312 38.539062 L 158.195312 25.289062 L 163.40625 25.289062 L 163.40625 22.203125 Z M 149.21875 22.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 176.210938 33.292969 C 177.28125 32.824219 178.113281 32.148438 178.695312 31.273438 C 179.273438 30.394531 179.570312 29.351562 179.570312 28.136719 C 179.570312 26.925781 179.273438 25.871094 178.703125 24.980469 C 178.121094 24.09375 177.308594 23.410156 176.25 22.929688 C 175.179688 22.441406 173.929688 22.203125 172.484375 22.203125 L 165.433594 22.203125 L 165.433594 38.539062 L 169.207031 38.539062 L 169.207031 33.996094 L 172.679688 33.996094 L 175.8125 38.539062 L 179.863281 38.539062 Z M 174.867188 30.230469 C 174.277344 30.730469 173.414062 30.988281 172.28125 30.988281 L 169.207031 30.988281 L 169.207031 25.292969 L 172.28125 25.292969 C 173.414062 25.292969 174.277344 25.535156 174.867188 26.023438 C 175.457031 26.515625 175.742188 27.21875 175.742188 28.136719 C 175.742188 29.054688 175.457031 29.742188 174.867188 30.230469 Z M 174.867188 30.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 192.761719 22.203125 L 188.40625 29.464844 L 184.058594 22.203125 L 180.050781 22.203125 L 186.363281 32.710938 L 186.363281 38.539062 L 190.136719 38.539062 L 190.136719 32.75 L 196.46875 22.203125 Z M 192.761719 22.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 5.457031 37.855469 C 4.992188 38.898438 3.453125 38.707031 3.238281 37.582031 C 0.675781 24.234375 -0.179688 4.003906 9.34375 1.382812 C 13.15625 0.34375 18.082031 3.238281 23.101562 8.082031 C 23.789062 8.746094 23.835938 9.828125 23.21875 10.558594 C 18.023438 16.703125 9.277344 29.28125 5.457031 37.855469 Z M 5.457031 37.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,9.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 47.796875 38.003906 C 47.664062 38.703125 46.667969 38.703125 46.535156 38.003906 C 45.253906 31.15625 41.425781 24.199219 33.847656 23.894531 C 27.664062 23.628906 17.972656 31.515625 11.128906 38.230469 C 10.355469 39.003906 9.09375 38.058594 9.621094 37.09375 C 13.882812 29.339844 20.273438 19.355469 25.664062 13.132812 L 30.703125 18.1875 C 31.003906 18.488281 31.492188 18.488281 31.789062 18.1875 L 33.375 16.613281 C 33.675781 16.3125 33.675781 15.816406 33.375 15.515625 L 28.210938 10.351562 C 28.644531 9.882812 29.132812 9.371094 29.660156 8.820312 L 34.851562 14.027344 C 35.152344 14.328125 35.636719 14.328125 35.9375 14.027344 L 37.519531 12.449219 C 37.824219 12.148438 37.824219 11.65625 37.519531 11.355469 L 32.375 6.210938 C 32.902344 5.71875 33.433594 5.261719 33.980469 4.828125 L 38.996094 9.863281 C 39.296875 10.164062 39.785156 10.164062 40.085938 9.863281 L 41.667969 8.285156 C 41.96875 7.984375 41.96875 7.488281 41.667969 7.1875 L 37.070312 2.59375 C 38.765625 1.589844 40.40625 1.0625 41.765625 1.382812 C 51.4375 3.691406 50.417969 24.605469 47.796875 37.996094 Z M 47.796875 38.003906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72516356b62e90dc35e574b3bb76e63a.svg";
export { ForwardRef as ReactComponent };